import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6dcdaaf2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6dcdaaf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcdaaf2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/drone/src/components/Breadcrumb/index.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default})
